import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16 4H8V1H6V4H2V9H22V4H18V1H16V4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 13V10.9999H2V22H12V21C12 16.5817 15.5817 13 20 13H22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.4143 18.2133L19.2867 14.0857L14 19.3724L14.0012 23.4999H18.1277L23.4143 18.2133ZM17.2007 19.0001L18.4999 20.2993L17.2993 21.4999H16.0006L16.0002 20.2006L17.2007 19.0001Z"}}]};

const CalendarEditFilled = Vue.extend<IconProps>({
  name: 'CalendarEditFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'calendar-edit-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CalendarEditFilled;
